// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__krZBu","logo":"Header_logo__ki3D5","shortcut":"Header_shortcut__Y5IuQ"};